import React, { Fragment } from 'react';
import Icon from '@ant-design/icons';
import classNames from 'classnames';
import DotSvg from '@icons/dot.svg';
import styles from './styles/Display.less';
import { DATE_SHORTCUTS } from '@utils/constants';

const hourFormat = 'HH:mm';
const dateFormat = 'MMM DD';
const yearFormat = 'YYYY';
const liveTrendsFormat = 'MMM DD, HH:mm:ss';

const Display = ({ interval, shortcut, selected, title, className, showShortcut, expanded }) => {
  const classes = classNames(styles.display, className, { [styles.selected]: selected });
  const sameYear = interval[0].isSame(interval[1], 'year');

  const renderInterval = (ts, withShortcut, withYear) => (
    <div className={styles.interval}>
      <div className={styles.date}>
        {!withShortcut ? <span className={styles.hour}>{ts.format(hourFormat)}</span> : null}
        <span className={styles.day}>{ts.format(dateFormat)}</span>
      </div>
      {withYear ? <span className={styles.year}>{ts.format(yearFormat)}</span> : null}
    </div>
  );

  const renderRTOnTrendsDisplay = (interval) => {
    return (
      <Fragment>
        <div className={classes}>
          {shortcut && showShortcut ? <div>{shortcut}</div> : null}
          <div className={styles.rtDate}>
            <div className={styles.LiveModeMarker} />
            <div className={styles.rtLiveText}>Live </div>
            <div className={styles.rtLiveDate}>{interval[1].format(liveTrendsFormat)}</div>
          </div>
          {(selected || expanded) && title ? <div className={styles.title}>{title}</div> : null}
        </div>
      </Fragment>
    );
  };

  const renderLiveDisplay = () => {
    return (
      <div className={styles.live}>
        <Icon component={DotSvg} />
        Live
      </div>
    );
  };

  const renderDateDisplay = () => {
    return (
      <div className={classes}>
        {shortcut && showShortcut ? <div>{shortcut}</div> : null}
        <div className={styles.intervals}>
          {renderInterval(interval[0], showShortcut, !sameYear)}
          <div className={styles.to}>to</div>
          {renderInterval(interval[1], showShortcut, true)}
        </div>
        {(selected || expanded) && title ? <div className={styles.title}>{title}</div> : null}
      </div>
    );
  };

  const renderDisplay = (shortcut, interval) => {
    switch (shortcut) {
      case 'live':
        return renderLiveDisplay();
        break;
      case DATE_SHORTCUTS.last15Mins:
        return renderRTOnTrendsDisplay(interval);
        break;
      default:
        return renderDateDisplay();
        break;
    }
  };

  return <Fragment>{renderDisplay(shortcut, interval)}</Fragment>;
};

Display.defaultProps = {
  selected: false,
  shortcut: '',
  title: 'Time Frame',
  className: '',
  showShortcut: false,
  expanded: false,
};

export default Display;
